var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dropdown',{attrs:{"id":_vm.id,"label":_vm.categoryLabel(_vm.category),"options":_vm.dropdownCategoryOptions,"right":"","variant":"outline-secondary"},on:{"input":function($event){return _vm.$emit('update:category', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }